import { inviteReducer } from './inviteSlice';

export * from './inviteSlice';
export * from './selectors';
export * from './hooks';

export const inviteReducers = {
   inviteData: inviteReducer,
};
